/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import Modal from 'react-modal'
import axios from 'axios'
import DOMPurify from 'dompurify'
import { swalChoose, swalSuccess } from '../../../common/components/Swaler'

const headerStyle = { color: '#006e78' }
// eslint-disable-next-line no-undef
const laughing = new Audio('https://iframe-assets.s3.eu-west-1.amazonaws.com/audios/laughing.wav')

const NewEmailForm = ({ selectedEmail, isOpen, closeModal }) => {
  const [subject, setSubject] = useState(selectedEmail?.subject || '')
  const [body, setBody] = useState(selectedEmail?.body || '')
  const [recipient, setRecipient] = useState(selectedEmail?.recipient || '')

  const sendEmail = () => {
    laughing.play()
    swalSuccess('🎉TADA!🎉', 'Mail skickat!')
    axios.post(`${window.MYQLOCX_API}/subject/admin/s_emails`, { subject, body, recipient, attachments: selectedEmail.attachments })
  }

  const handleSendNewEmail = () => {
    swalChoose('Säker?', `Vill du verkligen skicka ett nytt mail till ${recipient}`, ['Ja', 'Avbryt']).then((r) => {
      if (r.dismiss) return
      sendEmail()
      closeModal()
    })
  }

  return (
    <Modal ariaHideApp={false} isOpen={isOpen} onRequestClose={closeModal}>
      <button onClick={closeModal}>Stäng</button>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ flex: 1, minWidth: '40%', paddingRight: 10 }}>
          <h2 style={headerStyle}>Uppdatera emaildetaljer</h2>
          <br />
          <div>
            <div style={{ display: 'flex', paddingTop: 10 }}>
              <div style={{ width: 100 }}>Mottagare</div>
              <input style={{ width: 500 }} type="email" name="recipient" value={recipient} onChange={(e) => setRecipient(e.target.value)} />
            </div>
            <div style={{ display: 'flex', paddingTop: 10 }}>
              <div style={{ width: 100 }}>Ämnesrad</div>
              <input style={{ width: 500 }} type="text" name="subject" value={subject} onChange={(e) => setSubject(e.target.value)} />
            </div>
            <div style={{ display: 'flex', paddingTop: 10 }}>
              <div style={{ width: 100 }}>Meddelande</div>
              <textarea style={{ width: 500, minHeight: 300 }} type="text" name="body" value={body} onChange={(e) => setBody(e.target.value)} />
            </div>
            <br />
            <button className="qButtonSmall" onClick={handleSendNewEmail}>
              Skicka
            </button>
          </div>
        </div>
        <div style={{ flex: 1, minWidth: '40%', borderLeft: '2px solid lightgrey', paddingLeft: 10 }}>
          <div>
            <h2 style={headerStyle}>Förhandsgranskning</h2>
            <br />
            <div style={{ boxShadow: '2px 2px 8px 2px grey', padding: 10 }}>
              <br />
              <h2 style={{ ...headerStyle, fontWeight: 'bold', fontSize: 26 }}>Ämne: {subject}</h2>
              <h2 style={{ ...headerStyle, fontWeight: 'bold', fontSize: 26 }}>Mottagare: {recipient}</h2>
              <br />
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{ flex: 1, padding: 10 }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body) }}></div>
              </div>
              <br />
              <hr />
              <br />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default NewEmailForm
